import { DropdownButton, MenuItem } from 'react-bootstrap';
import { IOpoCase, OpoCaseStatus, OpoCaseStatusDescription } from '@nkr/models/opo-case';
import { formatDateTime } from './helpers';
import { StatusPill } from './styles';

interface IProps {
    opoCase: IOpoCase,
    showStatus: boolean,
    onEdit: (opoCase: IOpoCase) => void,
    onClose: (opoCase: IOpoCase) => void,
    onStatusChange: (opoCase: IOpoCase, statusId: OpoCaseStatus) => void,
    onDelete: (opoCase: IOpoCase) => void
}

const CaseRow = ({ opoCase, showStatus, onEdit, onClose, onStatusChange, onDelete }: IProps) => {
    const isPending = opoCase.statusId == OpoCaseStatus.Pending;
    const isCompleted = opoCase.statusId == OpoCaseStatus.Completed;

    return (
        <tr>
            <td>{opoCase.caseNumber}</td>
            <td>{opoCase.unosId}</td>
            <td>{opoCase.originCenterAlias}</td>
            <td>{opoCase.intendedCenterAlias}</td>
            <td>{opoCase.actualCenterAlias}</td>
            <td>{formatDateTime(opoCase.scheduledPickupDateTime)}</td>
            <td>{formatDateTime(opoCase.scheduledDeliveryDateTime)}</td>
            {showStatus && (
                <td>{opoCase.actualPickupDateTime ? formatDateTime(opoCase.actualPickupDateTime) : <>&ndash;</>}</td>
            )}
            {showStatus && (
                <td>{opoCase.actualDeliveryDateTime ? formatDateTime(opoCase.actualDeliveryDateTime) : <>&ndash;</>}</td>
            )}
            <td>
                {opoCase.gpsLink ?
                    <div className='btn-group'>
                        <button type='button' className='btn btn-default' onClick={() => window.open(opoCase.gpsLink, '_blank', 'noopener')}>GPS</button>
                    </div>
                    :
                    <>&ndash;</>
                }
            </td>
            {showStatus && (
                <td>{isCompleted ? (opoCase.wentToIntendedCenter ? 'Yes' : 'No') : <>&ndash;</>}</td>
            )}
            {showStatus && (
                <td><StatusPill $status={opoCase.statusId}>{OpoCaseStatusDescription[opoCase.statusId]}</StatusPill></td>
            )}
            <td>
                <DropdownButton id={`case-actions-${opoCase.id}`} bsStyle='primary' bsSize='xsmall' title='Actions' pullRight>
                    <MenuItem onSelect={() => onEdit(opoCase)}>Edit</MenuItem>
                    {isPending && (
                        <MenuItem onSelect={() => onClose(opoCase)}>Close Case</MenuItem>
                    )}
                    {isPending && (
                        <MenuItem onSelect={() => onStatusChange(opoCase, OpoCaseStatus.Cancelled)}>Cancel Case</MenuItem>
                    )}
                    {!isPending && (
                        <MenuItem onSelect={() => onStatusChange(opoCase, OpoCaseStatus.Pending)}>Reopen Case</MenuItem>
                    )}
                    <MenuItem divider />
                    <MenuItem className='danger' onSelect={() => onDelete(opoCase)}>Delete</MenuItem>
                </DropdownButton>
            </td>
        </tr>
    );
}

export default CaseRow;
